import React from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import BasicAnnotation from "./BasicAnnotation";
import BasicMarker from "./BasicMarker";
import BasicWorldMapCard from "./BasicWorldMapCard";
import CustomMarker from "./CustomMarker";

const GoogleMapContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle="Google Map" parent="Maps" title="Google Map" />
      <Row>
        <BasicAnnotation />
        <BasicMarker />
        <BasicWorldMapCard />
        <CustomMarker />
      </Row>
    </Container>
  );
};

export default GoogleMapContain;
